export default __webpack_public_path__ + "static/global-collaboration-program-6f3e6dd34d3cb349d534c6647f1769ce.png";